import React, { forwardRef } from "react";
import AsyncSelect from "react-select/async";
import { selectStyles, ValidationText } from "..";

export const AsyncMultiSelect = forwardRef(
	(
		{
			onChange = () => {},
			placeholder = "Hello",
			disabled,
			loading,
			defaultValue,
			value,
			searchable,
			departmentId,
			id,
			apiOptions,
			isError = false,
			errorText = "",
			cacheOptions,
			...field
		},
		ref
	) => {
		const handleChange = async (value) => {
			const awaitedValue = await value;
			onChange(awaitedValue);
		};

		const handleLoadOptions = (query) =>
			departmentId ? apiOptions(query, departmentId) : apiOptions(query);
		return (
			<>
				<AsyncSelect
					{...field}
					placeholder={placeholder}
					onChange={handleChange}
					defaultValue={defaultValue}
					isDisabled={disabled}
					isLoading={loading}
					loadOptions={handleLoadOptions}
					cacheOptions={cacheOptions}
					styles={selectStyles({ isError })}
					ref={ref}
				/>
				<div>
					{errorText.length > 0 && (
						<ValidationText status={"error"} message={errorText} />
					)}
				</div>
			</>
		);
	}
);
